import { gql } from '@apollo/client';

export const REFUND_APP_ORDER = gql`
  mutation refundAppOrder($orderId: ID!) {
    refundOrder(orderId: $orderId) {
      success
      error
      message
    }
  }
`;

export const REFUND_POS_ORDER = gql`
  mutation refundPosOrder($orderId: ID!) {
    refundPosOrder(orderId: $orderId) {
      success
      error
      message
    }
  }
`;

export const REFUND_ITEM = gql`
  mutation refundOrderItem($orderId: ID!, $itemId: ID!) {
    refundOrderItem(orderId: $orderId, itemId: $itemId) {
      success
      error
      message
    }
  }
`;

export const REFUND_TIP = gql`
  mutation refundTip($orderId: ID!, $tipAmount: Int!, $transactions: [TransactionInput!]!) {
    refundTip(orderId: $orderId, tipAmount: $tipAmount, transactions: $transactions) {
      error
      success
      message
    }
  }
`;

export const REFUND_MULTIPAY_TIP = gql`
  mutation refundMultiPayTips(
    $orderId: ID!
    $subPayments: [RefundMultiPayTipsInput!]!
    $transactions: [TransactionInput!]!
  ) {
    refundMultiPayTips(orderId: $orderId, subPayments: $subPayments, transactions: $transactions) {
      error
      success
      message
    }
  }
`;
